'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    FE_ERROR: 'FE_ERROR',
    FE_WARNING: 'FE_WARNING',
    FE_INFO: 'FE_INFO',
    FE_DEBUG: 'FE_DEBUG'
};
//# sourceMappingURL=alertLevel.js.map